import { Reducer } from '@reduxjs/toolkit'

import {
  ActionTypes,
  GET_PERSON_REVENUES_REQUEST,
  GET_PERSON_REVENUES_SUCCESS,
  GET_PERSON_REVENUES_FAILURE,
  GET_PERSON_TARGETS_REQUEST,
  GET_PERSON_TARGETS_SUCCESS,
  GET_PERSON_TARGET_FAILURE,
  CREATE_PERSON_TARGET_REQUEST,
  CREATE_PERSON_TARGET_SUCCESS,
  CREATE_PERSON_TARGET_FAILURE,
  DELETE_PERSON_TARGET_REQUEST,
  DELETE_PERSON_TARGET_SUCCESS,
  DELETE_PERSON_TARGET_FAILURE,
  UPDATE_PERSON_TARGET_REQUEST,
  UPDATE_PERSON_TARGET_SUCCESS,
  UPDATE_PERSON_TARGET_FAILURE,
} from './ActionTypes'
import ITargetState from './ITargetState'

export const initialTargetState: ITargetState = {
  loading: false,
  list: null,
  personRevenues: null,
  errors: [],
}

export const personTargetsReducer: Reducer<ITargetState, ActionTypes> = (
  state = initialTargetState,
  action,
) => {
  switch (action.type) {
    case GET_PERSON_REVENUES_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case GET_PERSON_REVENUES_SUCCESS:
      return {
        ...state,
        loading: false,
        personRevenues: action.payload.personRevenues,
      }
    case GET_PERSON_REVENUES_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case GET_PERSON_TARGETS_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case GET_PERSON_TARGETS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.personTargets,
      }
    case GET_PERSON_TARGET_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case CREATE_PERSON_TARGET_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case CREATE_PERSON_TARGET_SUCCESS:
      // todo: improve logic by setting default state as []. Why not now? Not easy to fix logic after doing so
      return state.list !== null
        ? {
            ...state,
            list: [...state.list, action.payload.personTarget],
            loading: false,
          }
        : {
            ...state,
            list: [action.payload.personTarget],
            loading: false,
          }
    case CREATE_PERSON_TARGET_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }
    case DELETE_PERSON_TARGET_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case DELETE_PERSON_TARGET_SUCCESS:
      const personTargetIndex = state.list.findIndex(
        personTarget => action.payload.personTarget.id === personTarget.id,
      )

      if (-1 === personTargetIndex) {
        return state
      }

      return {
        ...state,
        loading: false,
        list: [
          ...state.list.slice(0, personTargetIndex),
          ...state.list.slice(personTargetIndex + 1),
        ],
      }
    case DELETE_PERSON_TARGET_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case UPDATE_PERSON_TARGET_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case UPDATE_PERSON_TARGET_SUCCESS:
      const oldPersonTargetIndex = state.list.findIndex(
        personTarget => action.payload.oldPersonTarget.id === personTarget.id,
      )

      if (-1 === oldPersonTargetIndex) {
        return state
      }

      const stateWithoutOldPersonTarget = [
        ...state.list.slice(0, oldPersonTargetIndex),
        ...state.list.slice(oldPersonTargetIndex + 1),
      ]

      return {
        ...state,
        list: [...stateWithoutOldPersonTarget, action.payload.newPersonTarget],
        loading: false,
      }
    case UPDATE_PERSON_TARGET_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
